/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Dialog_Edit_DescriptionInputs */



/**
* | output |
* | --- |
* | "Modify the alarm." |
*
* @param {Alarms_Dialog_Edit_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_dialog_edit_description = /** @type {((inputs?: Alarms_Dialog_Edit_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Dialog_Edit_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Modify the alarm.")
	return /** @type {LocalizedString} */ ("Modifier l'alarme.")
});